module.exports = __webpack_public_path__ + "img/prizeRanking3.f700216f.png";